<script>
import page from 'Pages/_contentSection/page/-page.vue';
export default page;
</script>
